import Backdrop from "@mui/material/Backdrop";
import AlertContext from "../../../context/AlertContext";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useContext, useEffect, useState } from "react";
import { StudentTestPageContext } from "../../../context/StudentTestPageContext";
import StudentTestBodyPageHooks from "../../../Hooks/StudentTestPage/StudentTestBodyPageHooks";
import StudentTestBodyPageSingleViewHooks from "../../../Hooks/StudentTestPage/StudentTestBodyPageSingleViewHooks";

export default function StudentTestBackDropCounter() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);

  const StudentTestBodyPageHks = StudentTestBodyPageHooks();
  const StudentTestBodyPageSingleViewHks = StudentTestBodyPageSingleViewHooks();

  const [count, setCount] = useState(5);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count - 1);
    }, 1000);

    if (count === 0) {
      clearInterval(interval);
      setShow(false);
      StudentTestPageCxt.setShowTimer(false);
      StudentTestPageCxt.setshowtransition(false);
      StudentTestBodyPageHks.startListening();

      // StudentTestBodyPageSingleViewHks.playQns(
      //   Alert.comingObj.videoqn === 1
      //     ? Alert.videoQn.current?.filter((data) => data?.selected)[0]?.name
      //     : Alert.queObj?.name
      // );
    }

    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    setShow(true);
    // StudentTestPageCxt.transcript.current = "";
    // StudentTestBodyPageSingleViewHks.playQns(
    //   "Prepare yourself! The question will be displayed to you in 5 seconds."
    // );
  }, []);

  return (
    <div className="backdrop-container">
      {show && (
        <Backdrop
          open={show}
          className="custom-backdrop"
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <div className="countdownSec">
            <CircularProgress
              size={120} // Adjust size as needed
              thickness={3}
              variant="determinate"
              value={(count / 5) * 100} // Adjust the value to match the countdown
              sx={{ color: "#F55533" }} // Color of the CircularProgress
            />
            <div className="countdownCount">{count}</div>
          </div>
        </Backdrop>
      )}
    </div>
  );
}
